import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { propBool, propChildren, propNumber, propStr, } from '@/helpers/custom-prop-types';
import NavigationListItem from './NavigationListItem';
/**
 * TODO: TS化 & tailwind化
 */
const NavigationList = (props) => {
    const { className, count, disabled, external, svg, text, to } = props;
    if (disabled) {
        return (_jsx(NavigationListItem, { className: className, count: count, svg: svg, text: text }));
    }
    return external ? (_jsx("a", Object.assign({ href: to }, { children: _jsx(NavigationListItem, { className: className, count: count, svg: svg, text: text }) }))) : (_jsx(Link, Object.assign({ to: to }, { children: _jsx(NavigationListItem, { className: className, count: count, svg: svg, text: text }) })));
};
NavigationList.propTypes = {
    className: propStr().isRequired,
    count: propNumber().isRequired,
    disabled: propBool(),
    external: propBool(),
    svg: propChildren().isRequired,
    text: propChildren().isRequired,
    to: propStr().isRequired,
};
NavigationList.defaultProps = {
    disabled: false,
    external: false,
};
export default NavigationList;
